import React from "react";
import "../css/pages/expertise.scss";
interface Props {}
const Expertise: React.FC<Props> = (Props) => {
  return (
    <>
      <section className="page-section" id="about">
        <div className="container">
          <div className="text-center">
            <h2 className="section-heading text-uppercase">حیطه های فعالیت</h2>
          </div>
          <ul className="timeline">
            <li>
              <div className="timeline-image"></div>
              <div className="timeline-panel">
                <div className="timeline-heading">
                  <h4 className="subheading">فیزیوتراپی</h4>
                </div>
                <div className="timeline-body">
                  <p className="text-muted">
                    فیزیوتراپی در واقع یکی از علوم اصلی توانبخشی است و در زیر
                    مجموعه توانبخشی قرار می‌گیرد. هدف اصلی از درمان فیزیوتراپی
                    بهبود عملکرد، افزایش دامنه حرکات، افزایش قدرت عضلات، انعطاف
                    عضلات، تحمل عضلات، بهبود زندگی فرد، بهبود وضعیت راه رفتن و
                    در نهایت بهبود عملکرد کلی فرد هست.
                  </p>
                </div>
              </div>
            </li>
            <li className="timeline-inverted">
              <div className="timeline-image"></div>
              <div className="timeline-panel">
                <div className="timeline-heading">
                  {/* <h4>March 2011</h4> */}
                  <h4 className="subheading">کاردرمانی </h4>
                </div>
                <div className="timeline-body">
                  <p className="text-muted">
                    کاردرمانی به افراد دارای مشکلات سلامتی (یا چالش هایی از
                    تندرستی) کمک می کند تا دوباره فعالیت های روزانه مهم خود را
                    شروع کنند. چون کاردرمانی بر کل بدن فرد متمرکز است،
                    کاردرمانگر نقش مهمی را در کمک کردن به شما ایفا می کند تا
                    بتوانید بر سلامت و زندگی خود تأثیر بگذارید.
                  </p>
                </div>
              </div>
            </li>
            <li>
              <div className="timeline-image"></div>
              <div className="timeline-panel">
                <div className="timeline-heading">
                  <h4 className="subheading">گفتاردرمانی </h4>
                </div>
                <div className="timeline-body">
                  <p className="text-muted">
                    گفتار درمانی یا پاتولوژی گفتار و زبان یکی از شاخه های
                    توانبخشی می باشد که به آسیب شناسی اختلالات مربوط به گفتار و
                    زبان می پردازد. در واقع گفتار و زبان بخش بسیار مهمی از
                    ارتباط برقرار کردن با دیگران است.
                  </p>
                </div>
              </div>
            </li>

            <li className="timeline-inverted">
              <div className="timeline-image"></div>
              <div className="timeline-panel">
                <div className="timeline-heading">
                  <h4 className="subheading">روانشناسی </h4>
                </div>
                <div className="timeline-body">
                  <p className="text-muted">
                    روانشناسی مطالعه ذهن و رفتار است که شامل تأثیرات زیست
                    شناختی، فشارهای اجتماعی و عوامل محیطی است که بر چگونگی تفکر،
                    عملکرد و حس افراد تاثیر می گذارد. با استفاده از علم
                    روانشناسی، روانپزشکان (متخصص اعصاب و روان) و روانشناسان به
                    معالجه اختلالات روانی و شناخت روان انسان ها مشغول اند.
                  </p>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </section>
    </>
  );
};
export default Expertise;
